const skillsSoftware = [
    { text: 'Github', icon: 'skill_advanced.png'},
    { text: 'AWS', icon: 'skill_intermediate.png'},
    { text: 'Milanote', icon: 'skill_intermediate.png'},
    { text: 'Notion', icon: 'skill_intermediate.png'},
  ];
  
  export default skillsSoftware;